import { createSlice } from "@reduxjs/toolkit";
export const newFloorApplication = createSlice({
    name: "newFloorApplication",
    initialState: {
        floorAppFormDetails: {
            appId: "",
            showStepSection: false,
        },
        flooringCaseFileter: {},
        flooringCaseDetailsFilter: {},
        flooringCaseOngoingFilters: {},
    },
    reducers: {
        setFloorAppFormDeatils: (state, action) => {
            return {
                ...state,
                floorAppFormDetails: {
                    ...state.floorAppFormDetails,
                    ...action.payload,
                },
            };
        },
        setFloorCaseFilter: (state, action) => {
            return {
                ...state,
                flooringCaseFileter: {
                    ...state.flooringCaseFileter,
                    ...action.payload,
                },
            };
        },
        setFloorCaseDetailsFilter: (state, action) => {
            return {
                ...state,
                flooringCaseDetailsFilter: {
                    ...state.flooringCaseDetailsFilter,
                    ...action.payload,
                },
            };
        },
        setFloorCaseOngoingFilter: (state, action) => {
            return {
                ...state,
                flooringCaseOngoingFilters: {
                    ...state.flooringCaseOngoingFilters,
                    ...action.payload,
                },
            };
        },

        resetFloorAppForm: (state) => {
            return {
                ...state,
                floorAppFormDetails: {
                    appId: "",
                    showStepSection: false,
                },
                flooringCaseFileter: {},
                flooringCaseDetailsFilter: {},
                flooringCaseOngoingFilters: {},
            };
        },
    },
});

export const {
    setFloorAppFormDeatils,
    setFloorCaseFilter,
    resetFloorAppForm,
    setFloorCaseDetailsFilter,
    setFloorCaseOngoingFilter
} = newFloorApplication.actions;

export default newFloorApplication.reducer;
